import { useContext, useEffect, useState } from "react";
import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Drawer, IconButton, Typography } from "@mui/material";
import { Menu, Logout, SpaceDashboard, LocalOffer, Add, ConfirmationNumber, EmojiEvents, CreditCard, RateReview, PeopleAlt, Redeem, PointOfSale, Assessment, AccountBalanceWallet, Settings, QrCode2, QrCode, FastForward, QrCodeScanner, SwapHoriz, Celebration, History } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DataContext } from "../../context/DataContext";
import { callPostApi } from "../../function/ApiCallFunction";
import { consoleColors, headingCase, primaryButtonSx } from "../admin/consoleTheme";
import { REACT_ENV } from "../../include/config";
import { formatAmount } from "../../include/money";
import { filterGroups, firstAllowedPath, isOwner, pathAllowed, STORE_MENU_CATALOG, staffOf } from "../../include/staffAccess";
import StoreInfoModal from "../../components/modal/StoreInfoModal";
import ThirdPartyApiInfo from "../../components/modal/ThirdPartyApiInfoModal";
import SellerStoreListInfo from "../../components/modal/SellerStoreListModal";
import StorePlusInfo from "../../components/modal/StorePlusInfoModal";

const SIDEBAR = 252;

const loyaltyGroups = (plusFlag) => [
  {
    label: "Overview",
    items: [
      { to: "/home", menu: "home", label: "Home", icon: SpaceDashboard },
      { to: "/dashboard", menu: "dashboard", label: "Loyalty Report", icon: Assessment },
      ...(plusFlag === "1" ? [{ to: "/dashboardPlus", menu: "dashboardPlus", label: "Cashi Plus", icon: QrCode2 }] : []),
    ],
  },
  {
    label: "OFFERS & ENGAGEMENT",
    items: [
      { to: "/couponlist", menu: "couponlist", label: "Coupons & Rewards", icon: LocalOffer },
      { to: "/createcoupon", menu: "createcoupon", label: "Create Coupon", icon: Add },
      { to: "/spinwin", menu: "spinwin", label: "Spin To Win", icon: Celebration },
      { to: "/luckydraws", menu: "luckydraws", label: "Lucky Draw Coupons", icon: EmojiEvents },
      { to: "/luckydrawcoupon", menu: "luckydrawcoupon", label: "Print Coupons", icon: ConfirmationNumber },
      { to: "/printphysicalcard", menu: "printphysicalcard", label: "Print Loyalty Cards", icon: CreditCard },
      { to: "/reviewList", menu: "reviewList", label: "Customer Reviews", icon: RateReview },
      ...(String(REACT_ENV) !== "LIVE" ? [{ to: "/campaignList", menu: "couponlist", label: "Campaigns", icon: LocalOffer }] : []),
    ],
  },
  {
    label: "Activity",
    items: [
      { to: "/customerList", menu: "customerList", label: "Customers", icon: PeopleAlt },
      { to: "/issuedList", menu: "issuedList", label: "Issued coupons", icon: ConfirmationNumber },
      { to: "/redeemedList", menu: "redeemedList", label: "Redeemed coupons", icon: Redeem },
      { to: "/saleReport", menu: "saleReport", label: "Sales", icon: PointOfSale },
      { to: "/registerSale", menu: "registerSale", label: "Register sale", icon: Add },
      { to: "/customerReport", menu: "customerReport", label: "Customer report", icon: Assessment },
      { to: "/physicalCard", menu: "physicalCard", label: "Issued cards", icon: CreditCard },
      { to: "/wallet", menu: "wallet", label: "Wallet", icon: AccountBalanceWallet },
      { to: "/audit", menu: "audit", label: "Audit trail", icon: History },
      { to: "/loyaltysetting", menu: "loyaltysetting", label: "Loyalty Settings", icon: Settings },
      { to: "/users", menu: "users", label: "Users", icon: PeopleAlt },
    ],
  },
];

const drawGroups = () => [
  {
    label: "Overview",
    items: [
      { to: "/home", menu: "home", label: "Dashboard", icon: SpaceDashboard },
    ],
  },
  {
    label: "OFFERS & ENGAGEMENT",
    items: [
      { to: "/spinwin", menu: "spinwin", label: "Spin To Win", icon: Celebration },
      { to: "/luckydraws", menu: "luckydraws", label: "Lucky Draw Coupons", icon: EmojiEvents },
      { to: "/luckydrawcoupon", menu: "luckydrawcoupon", label: "Print Coupons", icon: ConfirmationNumber },
      { to: "/registerSale", menu: "registerSale", label: "Register Sale", icon: Add },
    ],
  },
  {
    label: "Activity",
    items: [
      { to: "/customerList", menu: "customerList", label: "Customers", icon: PeopleAlt },
      { to: "/saleReport", menu: "saleReport", label: "Sales", icon: PointOfSale },
      { to: "/wallet", menu: "wallet", label: "Wallet", icon: AccountBalanceWallet },
      { to: "/audit", menu: "audit", label: "Audit trail", icon: History },
      { to: "/users", menu: "users", label: "Users", icon: PeopleAlt },
    ],
  },
];

function planLabel(flag) {
  if (flag === "3") return "Lucky Draw Coupons";
  if (flag === "2") return "Cashi Plus";
  if (flag === "1") return "Loyalty + Plus";
  return "Loyalty";
}

const plusGroups = (plusFlag) => [
  {
    label: "Overview",
    items: [
      { to: "/dashboardPlus", menu: "dashboardPlus", label: "Home", icon: SpaceDashboard },
      ...(plusFlag === "1" ? [{ to: "/home", menu: "home", label: "Loyalty home", icon: Assessment }] : []),
    ],
  },
  {
    label: "QR coupons",
    items: [
      { to: "/dashboardPlus/spinwin", menu: "spinwin", label: "Spin To Win", icon: Celebration },
      { to: "/dashboardPlus/loadQR", menu: "loadQR", label: "QR list", icon: QrCode2 },
      { to: "/dashboardPlus/generatedQR", menu: "generatedQR", label: "Generated", icon: QrCode },
      { to: "/dashboardPlus/loadedQR", menu: "loadedQR", label: "Loaded", icon: FastForward },
      { to: "/dashboardPlus/activatedQR", menu: "activatedQR", label: "Activated", icon: QrCodeScanner },
      { to: "/dashboardPlus/loadnactiveqr", menu: "loadnactiveqr", label: "Load and activate", icon: QrCode2 },
      { to: "/dashboardPlus/redeemed", menu: "plusRedeemed", label: "Redeemed", icon: Redeem },
      { to: "/dashboardPlus/totalPlusCustomer", menu: "plusCustomers", label: "Customers", icon: PeopleAlt },
      { to: "/dashboardPlus/walletPlus", menu: "walletPlus", label: "Wallet", icon: AccountBalanceWallet },
      { to: "/dashboardPlus/users", menu: "users", label: "Users", icon: PeopleAlt },
    ],
  },
];

const titles = {
  "/": ["Home", "Store overview"],
  "/home": ["Home", "Store overview"],
  "/dashboard": ["Loyalty report", "Points, sales, and customers"],
  "/dashboardPlus": ["Cashi Plus", "QR coupons for this store"],
  "/luckydraws": ["Lucky Draw Coupons", "Coupons for this store"],
  "/spinwin": ["Spin To Win", "Wheels for this store"],
  "/spinwin/new": ["Create Spin To Win", "Options, chances, and dates"],
  "/dashboardPlus/spinwin": ["Spin To Win", "Wheels for this store"],
  "/dashboardPlus/spinwin/new": ["Create Spin To Win", "Options, chances, and dates"],
  "/luckydraws/new": ["Create Lucky Draw Coupons", "A coupon draw for this store"],
  "/luckydrawcoupon": ["Print Lucky Draw Coupons", "Front cards for the selected draw"],
  "/printphysicalcard": ["Print Loyalty Cards", "Request printed loyalty cards from this store"],
  "/printphysicalcard/new": ["Request Printed Cards", "Number of cards and wallet cut"],
  "/users": ["Users", "Emails, login ids, and menu permission"],
  "/users/new": ["Add user", "Email and menus this user can open"],
  "/dashboardPlus/users": ["Users", "Emails, login ids, and menu permission"],
  "/dashboardPlus/users/new": ["Add user", "Email and menus this user can open"],
  "/printphysicalcard/design": ["Print physical card", "Print front, back, and QR"],
  "/luckydrawcouponback": ["Print Lucky Draw Coupons Back", "Back side of the selected draw"],
  "/registerSale": ["Sales Calculator", "Add the bill, then scan the printed coupon"],
  "/luckydrawredeem": ["Lucky Draw Coupons", "Issued coupons for the selected dates"],
  "/luckydrawwinner": ["Lucky Draw Coupons Winner", "The customer picked for this draw"],
  "/couponlist": ["Coupons & Rewards", "Offers for this store"],
  "/createcoupon": ["Create Coupon", "Add a new offer"],
  "/wallet": ["Wallet", "Balance and transactions"],
  "/audit": ["Audit trail", "Sales, wallet, coupons, and print movements for this store"],
  "/dashboardPlus/walletPlus": ["Wallet", "Balance and transactions"],
  "/customerList": ["Customers", "People enrolled at this store, with loyalty points"],
  "/issuedList": ["Issued coupons", "Coupons given to customers"],
  "/redeemedList": ["Redeemed coupons", "Coupons already used"],
  "/reviewList": ["Customer Reviews", "Customer feedback"],
  "/loyaltysetting": ["Loyalty settings", "How points are earned and spent"],
  "/dashboardPlus/loadQR": ["QR list", "Load value onto QR coupons"],
  "/dashboardPlus/generatedQR": ["Generated QR", "Coupons waiting to be loaded"],
  "/dashboardPlus/loadedQR": ["Loaded QR", "Coupons with a value"],
  "/dashboardPlus/activatedQR": ["Activated QR", "Coupons ready for customers"],
  "/dashboardPlus/redeemed": ["QR redeems", "Customers who redeemed a code"],
  "/dashboardPlus/totalPlusCustomer": ["Customers", "Cashi Plus customers"],
};

function NavItem({ item, active, onClick }) {
  const Icon = item.icon;
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex", alignItems: "center", gap: 1.2, px: 1.2, py: 0.9, mb: 0.3, borderRadius: 1.5, cursor: "pointer",
        color: active ? "#fff" : consoleColors.navText,
        background: active ? consoleColors.navActive : "transparent",
        "&:hover": { background: active ? consoleColors.navActive : "rgba(255,255,255,0.06)" },
      }}
    >
      <Icon sx={{ fontSize: 18, color: active ? consoleColors.accent : consoleColors.navMuted }} />
      <Typography sx={{ fontSize: 14, fontWeight: active ? 650 : 500 }}>{headingCase(item.label)}</Typography>
    </Box>
  );
}

export default function StoreShell({ mode, onLogout, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginData, setLoginData } = useContext(DataContext);
  const storeInfo = loginData?.store_info || {};
  const storeName = storeInfo.store_name || "Store";
  const plusFlag = storeInfo.cashi_plus_flag || "0";
  const wallet = Number(storeInfo.wallet_amount || 0);
  const welcome = storeInfo.cashi_plus_welcome;
  const storeList = Array.isArray(storeInfo.store_list) ? storeInfo.store_list : [];
  const rawGroups = plusFlag === "3" ? drawGroups() : (mode === "plus" ? plusGroups(plusFlag) : loyaltyGroups(plusFlag));
  const groups = filterGroups(rawGroups, loginData);
  const staff = staffOf(loginData);
  const walletPath = mode === "plus" ? "/dashboardPlus/walletPlus" : "/wallet";
  const spinPath = location.pathname.replace(/^\/dashboardPlus/, "");
  const spinTitle = spinPath === "/spinwin" || titles[location.pathname] ? null
    : spinPath.endsWith("/edit") && spinPath.startsWith("/spinwin/") ? ["Edit Spin To Win", "Update this wheel"]
    : spinPath.endsWith("/wheel") && spinPath.startsWith("/spinwin/") ? ["Spin To Win", "Spin the wheel, then show the QR"]
    : spinPath.endsWith("/winners") && spinPath.startsWith("/spinwin/") ? ["Prize List", "Customers and whether the prize was given"]
    : null;
  const [title, subtitle] = titles[location.pathname]
    || spinTitle
    || (location.pathname.startsWith("/customerList/") ? ["Customer history", "Purchases, loyalty, visits, and coupons"] : null)
    || (location.pathname.startsWith("/luckydraws/") && location.pathname.endsWith("/launch") ? ["Launch Draw", "Countdown, then the winner"] : null)
    || (location.pathname.startsWith("/luckydraws/") && location.pathname.endsWith("/edit") ? ["Edit Lucky Draw Coupons", "Update this store draw"] : null)
    || (location.pathname.startsWith("/users/") && location.pathname.endsWith("/edit") ? ["Edit user", "Email and menus this user can open"] : null)
    || (location.pathname.startsWith("/dashboardPlus/users/") && location.pathname.endsWith("/edit") ? ["Edit user", "Email and menus this user can open"] : null)
    || (location.pathname.startsWith("/luckydraw/") ? ["Lucky Draw Coupons", "Results, issued coupons, and winners"] : ["Store", storeName]);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [logoutOpen, setLogoutOpen] = useState(false);
  const [claimOpen, setClaimOpen] = useState(false);
  const [modalState, setModalState] = useState({ type: null, data: null });

  useEffect(() => {
    const onEsc = (event) => { if (event.key === "Escape") setModalState({ type: null, data: null }); };
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, []);

  useEffect(() => {
    if (isOwner(loginData) || pathAllowed(location.pathname, loginData, STORE_MENU_CATALOG)) return;
    const sourceGroups = plusFlag === "3" ? drawGroups() : (mode === "plus" ? plusGroups(plusFlag) : loyaltyGroups(plusFlag));
    const next = firstAllowedPath(loginData, sourceGroups, mode === "plus" ? "/dashboardPlus" : "/home");
    if (next && next !== location.pathname) navigate(next, { replace: true });
  }, [location.pathname, loginData, mode, navigate, plusFlag]);

  const go = (path) => {
    setMobileOpen(false);
    navigate(path);
  };

  const claimWelcome = async () => {
    try {
      const apiResult = await callPostApi("store-wallet", { mod: "ADD_CASHI_PLUS_WELCOME", data_arr: { store_id: storeInfo.store_id } });
      if (apiResult.status === "200") {
        toast.success(apiResult.data.message);
        setLoginData((prev) => {
          const updated = {
            ...prev,
            store_info: {
              ...prev.store_info,
              ...apiResult.data.store_info,
              wallet_amount: Number(prev?.store_info?.wallet_amount || 0) + 500,
              cashi_plus_welcome: "1",
            },
          };
          sessionStorage.setItem("loginData", JSON.stringify(updated));
          return updated;
        });
        setClaimOpen(true);
      } else {
        toast.info(apiResult.status_message);
      }
    } catch {
      toast.error("Something went wrong");
    }
  };

  const sidebar = (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", background: consoleColors.sidebar, color: "#fff" }}>
      <Box sx={{ px: 2.5, py: 2.5 }}>
        <Typography sx={{ fontSize: 13, letterSpacing: 1.4, color: consoleColors.gold, fontWeight: 700 }}>CASHI</Typography>
        <Typography sx={{ fontSize: 18, fontWeight: 700, mt: 0.2 }}>{mode === "plus" ? "Plus" : "Store"}</Typography>
        <Typography sx={{ fontSize: 12, color: consoleColors.navMuted, mt: 0.3 }}>{planLabel(plusFlag)}</Typography>
      </Box>
      <Box sx={{ flex: 1, overflowY: "auto", px: 1.5, pb: 2 }}>
        {groups.map((group) => (
          <Box key={group.label} sx={{ mb: 2 }}>
            <Typography sx={{ px: 1.2, mb: 0.6, fontSize: 11, letterSpacing: 0.8, color: consoleColors.navMuted, fontWeight: 700 }}>{group.label.toUpperCase()}</Typography>
            {group.items.map((item) => (
              <NavItem key={item.to} item={item} active={location.pathname === item.to || (item.to !== "/home" && item.to !== "/dashboardPlus" && location.pathname.startsWith(`${item.to}/`))} onClick={() => go(item.to)} />
            ))}
          </Box>
        ))}
      </Box>
      <Box sx={{ px: 2, py: 1.5, borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        <Box onClick={() => go(walletPath)} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", mb: 1.2, px: 0.4 }}>
          <Typography sx={{ fontSize: 12, color: consoleColors.navMuted }}>Wallet</Typography>
          <Typography sx={{ fontSize: 14, fontWeight: 700 }}>₹{formatAmount(wallet)}</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
          <Avatar sx={{ width: 34, height: 34, bgcolor: consoleColors.accent, fontSize: 14 }}>{storeName.charAt(0).toUpperCase()}</Avatar>
          <Box onClick={() => mode === "loyalty" && setModalState({ type: "info", data: storeInfo })} sx={{ flex: 1, minWidth: 0, cursor: mode === "loyalty" ? "pointer" : "default" }}>
            {mode === "plus" ? <StorePlusInfo quiet /> : (
              <>
                <Typography noWrap sx={{ fontSize: 13.5, fontWeight: 650 }}>{staff?.name || storeName}</Typography>
                <Typography sx={{ fontSize: 12, color: consoleColors.navMuted }}>{staff && !staff.is_owner ? staff.username : "Store account"}</Typography>
              </>
            )}
          </Box>
          {storeList.length > 1 && (
            <IconButton size="small" sx={{ color: "#cbd5e1" }} aria-label="Switch store" onClick={() => setModalState({ type: "SELLER_STORE", data: storeInfo })}>
              <SwapHoriz sx={{ fontSize: 18 }} />
            </IconButton>
          )}
          <IconButton size="small" sx={{ color: "#cbd5e1" }} aria-label="Logout" onClick={() => setLogoutOpen(true)}>
            <Logout sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", background: consoleColors.page }}>
      <Box sx={{ width: SIDEBAR, flexShrink: 0, display: { xs: "none", md: "block" } }}>
        <Box sx={{ position: "fixed", width: SIDEBAR, height: "100vh" }}>{sidebar}</Box>
      </Box>
      <Drawer open={mobileOpen} onClose={() => setMobileOpen(false)} sx={{ display: { md: "none" }, "& .MuiDrawer-paper": { width: SIDEBAR, border: 0 } }}>
        {sidebar}
      </Drawer>

      <Box sx={{ flex: 1, minWidth: 0, overflowX: "auto" }}>
        <Box sx={{ position: "sticky", top: 0, zIndex: 10, background: consoleColors.pageBar, backdropFilter: "blur(8px)", borderBottom: `1px solid ${consoleColors.line}`, px: { xs: 2, md: 3 }, py: 1.6, display: "flex", alignItems: "center", gap: 1.5 }}>
          <IconButton onClick={() => setMobileOpen(true)} sx={{ display: { md: "none" } }} aria-label="Open menu"><Menu /></IconButton>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: 18, fontWeight: 700, color: consoleColors.ink, lineHeight: 1.2 }}>{headingCase(title)}</Typography>
            <Typography sx={{ fontSize: 13, color: consoleColors.muted }}>{headingCase(subtitle)}</Typography>
          </Box>
          <Box
            onClick={() => go(walletPath)}
            sx={{ display: "flex", alignItems: "center", gap: 0.7, cursor: "pointer", background: "#fff", border: `1px solid ${consoleColors.line}`, borderRadius: 2, px: 1.2, py: 0.55, flexShrink: 0 }}
          >
            <AccountBalanceWallet sx={{ fontSize: 18, color: consoleColors.accent }} />
            <Box>
              <Typography sx={{ fontSize: 11, color: consoleColors.muted, lineHeight: 1.1 }}>Wallet balance</Typography>
              <Typography sx={{ fontSize: 15, fontWeight: 800, color: consoleColors.ink, lineHeight: 1.2 }}>₹{formatAmount(wallet)}</Typography>
            </Box>
          </Box>
        </Box>

        {welcome === "0" && (
          <Box sx={{ mx: { xs: 2, md: 3 }, mt: 2, p: 1.5, borderRadius: 2, background: "#fff", border: `1px solid ${consoleColors.line}`, display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
            <Celebration sx={{ color: "#b45309" }} />
            <Typography sx={{ flex: 1, color: consoleColors.ink, fontSize: 14 }}>A welcome bonus of ₹500 is waiting in your wallet.</Typography>
            <Button size="small" variant="contained" sx={primaryButtonSx} onClick={claimWelcome}>Claim ₹500</Button>
          </Box>
        )}

        <Box className="store-panel" sx={{ minWidth: 0 }}>{children}</Box>
      </Box>

      <Dialog open={logoutOpen} onClose={() => setLogoutOpen(false)}>
        <DialogTitle>Log out</DialogTitle>
        <DialogContent><DialogContentText>Are you sure you want to log out?</DialogContentText></DialogContent>
        <DialogActions>
          <Button onClick={() => setLogoutOpen(false)} sx={{ textTransform: "none" }}>Cancel</Button>
          <Button variant="contained" sx={primaryButtonSx} onClick={() => { setLogoutOpen(false); onLogout(); }}>Log out</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={claimOpen} onClose={() => { setClaimOpen(false); navigate(walletPath); }}>
        <DialogTitle>Bonus added</DialogTitle>
        <DialogContent><DialogContentText>₹500 has been added to your wallet.</DialogContentText></DialogContent>
        <DialogActions>
          <Button variant="contained" sx={primaryButtonSx} onClick={() => { setClaimOpen(false); navigate(walletPath); }}>Go to wallet</Button>
        </DialogActions>
      </Dialog>

      {modalState.type === "info" && <StoreInfoModal dataArr={modalState.data} onClose={() => setModalState({ type: null, data: null })} openModal={(type, data) => setModalState({ type, data })} />}
      {modalState.type === "API_DOC" && <ThirdPartyApiInfo dataArr={modalState.data} onClose={() => setModalState({ type: null, data: null })} />}
      {modalState.type === "SELLER_STORE" && <SellerStoreListInfo dataArr={modalState.data} onClose={() => setModalState({ type: null, data: null })} />}
    </Box>
  );
}
